<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<project-form :project-id="id" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import projectForm from '@/components/projects/project-form';

function closeModal() {
	this.goTo('page-project');
}

function title() {
	const project = 'Proyecto';
	return this.id ? `Editar ${project}` : `Crear ${project}`;
}

export default {
	name: 'page-project-new',
	components: {
		actionSidebar,
		projectForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/projects/page-project-new.vue